export default {
  // Personal information section
  personalInformation: {
    id: 'bo_seller.kyb.stakeholder.personal_information',
    defaultMessage: 'Personal information',
  },
  firstName: {
    id: 'bo_seller.kyb.stakeholder.first_name',
    defaultMessage: 'First name',
  },
  kanaFirstName: {
    id: 'bo_seller.kyb.stakeholder.kana_first_name',
    defaultMessage: 'First name (kana)',
  },
  latinFirstName: {
    id: 'bo_seller.kyb.stakeholder.latin_first_name',
    defaultMessage: 'First name (latin)',
  },
  lastName: {
    id: 'bo_seller.kyb.stakeholder.last_name',
    defaultMessage: 'Last name',
  },
  kanaLastName: {
    id: 'bo_seller.kyb.stakeholder.kana_last_name',
    defaultMessage: 'Last name (kana)',
  },
  latinLastName: {
    id: 'bo_seller.kyb.stakeholder.latin_last_name',
    defaultMessage: 'Last name (latin)',
  },
  dateOfBirth: {
    id: 'bo_seller.kyb.stakeholder.date_of_birth',
    defaultMessage: 'Date of birth',
  },
  countryOfCitizenship: {
    id: 'bo_seller.kyb.stakeholder.country_of_citizenship',
    defaultMessage: 'Country/region of citizenship',
  },
  countryOfBirth: {
    id: 'bo_seller.kyb.stakeholder.country_of_birth',
    defaultMessage: 'Country/region of birth',
  },
  phoneNumber: {
    id: 'bo_seller.kyb.stakeholder.phone_number',
    defaultMessage: 'Phone number',
  },
  clearPhoneNumber: {
    id: 'bo_seller.kyb.stakeholder.clear_phone_number',
    defaultMessage: 'Clear phone number',
  },
  countryOfResidency: {
    id: 'bo_seller.kyb.stakeholder.country_of_residency',
    defaultMessage: 'Country/region of residency',
  },

  // Address section
  address: {
    id: 'bo_seller.kyb.stakeholder.address',
    defaultMessage: 'Home address',
  },

  // Photo ID section
  identityDocument: {
    id: 'bo_seller.kyb.stakeholder.photo_id',
    defaultMessage: 'Government-issued photo ID',
  },
  photoIdDescription: {
    id: 'bo_seller.kyb.stakeholder.photo_id_description',
    defaultMessage: 'This can be your passport, national identity card, etc.',
  },
  identificationType: {
    id: 'bo_seller.kyb.stakeholder.identification_type',
    defaultMessage: 'Identification type',
  },
  countryOfIssue: {
    id: 'bo_seller.kyb.stakeholder.country_of_issue',
    defaultMessage: 'Country/region of issue',
  },
  passport: {
    id: 'bo_seller.kyb.stakeholder.passport',
    defaultMessage: 'Passport',
  },
  nationalIdentityCard: {
    id: 'bo_seller.kyb.stakeholder.national_identity_card',
    defaultMessage: 'National identity card',
  },
  uploadFrontSide: {
    id: 'bo_seller.kyb.stakeholder.upload_front_side',
    defaultMessage: 'Upload front side',
  },
  uploadBackSide: {
    id: 'bo_seller.kyb.stakeholder.upload_back_side',
    defaultMessage: 'Upload back side',
  },
  uploadPassportPhoto: {
    id: 'bo_seller.kyb.stakeholder.upload_passport_photo',
    defaultMessage: 'Upload passport photo',
  },

  // Validation messages
  firstNameRequired: {
    id: 'bo_seller.kyb.stakeholder.first_name_required',
    defaultMessage: 'First name is required',
  },
  lastNameRequired: {
    id: 'bo_seller.kyb.stakeholder.last_name_required',
    defaultMessage: 'Last name is required',
  },
  dateOfBirthRequired: {
    id: 'bo_seller.kyb.stakeholder.date_of_birth_required',
    defaultMessage: 'Date of birth is required',
  },
  countryOfCitizenshipRequired: {
    id: 'bo_seller.kyb.stakeholder.country_of_citizenship_required',
    defaultMessage: 'Country of citizenship is required',
  },
  phoneNumberRequired: {
    id: 'bo_seller.kyb.stakeholder.phone_number_required',
    defaultMessage: 'Phone number is required',
  },
  phoneNumberInvalid: {
    id: 'bo_seller.kyb.stakeholder.phone_number_invalid',
    defaultMessage: 'Phone number is invalid',
  },
  countryOfResidencyRequired: {
    id: 'bo_seller.kyb.stakeholder.country_of_residency_required',
    defaultMessage: 'Country of residency is required',
  },
  addressLine1Required: {
    id: 'bo_seller.kyb.stakeholder.address_line_1_required',
    defaultMessage: 'Address line 1 is required',
  },
  cityRequired: {
    id: 'bo_seller.kyb.stakeholder.city_required',
    defaultMessage: 'City is required',
  },
  postalCodeRequired: {
    id: 'bo_seller.kyb.stakeholder.postal_code_required',
    defaultMessage: 'Postal code is required',
  },
  countryRequired: {
    id: 'bo_seller.kyb.stakeholder.country_required',
    defaultMessage: 'Country is required',
  },
  identificationTypeRequired: {
    id: 'bo_seller.kyb.stakeholder.identification_type_required',
    defaultMessage: 'Identification type is required',
  },
  countryOfIssueRequired: {
    id: 'bo_seller.kyb.stakeholder.country_of_issue_required',
    defaultMessage: 'Country of issue is required',
  },
  photoIdFrontRequired: {
    id: 'bo_seller.kyb.stakeholder.photo_id_front_required',
    defaultMessage: 'Photo ID front is required',
  },
  photoIdBackRequired: {
    id: 'bo_seller.kyb.stakeholder.photo_id_back_required',
    defaultMessage: 'Photo ID back is required',
  },

  // Actions
  saveButton: {
    id: 'bo_seller.kyb.stakeholder.save_button',
    defaultMessage: 'Save',
  },
} as const
